/** Keep each card in the nearest slot around the active card, across either seam. */
export function slidePosition(index, active, count) {
    const half = Math.floor(count / 2);
    return ((index - active + count + half) % count) - half;
}

/** Match the reference's distance threshold and quick-flick threshold. */
export function swipeDirection(offset, velocity) {
    if (Math.abs(offset) > 50 || (Math.abs(velocity) > 350 && Math.abs(offset) > 20)) {
        return offset < 0 ? 1 : -1;
    }
    return 0;
}
